import React from 'react';
import { Award, Users, Building, TrendingUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Gallery = () => {
    const navigate = useNavigate()
    const achievements = [
        {
            image: './award.jpg',
            title: 'Awards & Recognition',
            description: 'Best Financial Advisory Firm 2023'
        },
        {
            image: './clients.jpg',
            title: 'Client Success Stories',
            description: 'Helping families achieve their dreams'
        },
        {
            image: './team2.jpg',
            title: 'Team Excellence',
            description: 'Certified financial experts'
        },
        {
            image: './office.jpg',
            title: 'Modern Office',
            description: 'State-of-the-art facilities'
        },
        {
            image: './meeting.jpg',
            title: 'Client Meetings',
            description: 'Personalized financial planning'
        },
        {
            image: './analysis.jpg',
            title: 'Investment Analysis',
            description: 'Data-driven investment strategies'
        }
    ];

    const milestones = [
        {
            icon: Users,
            number: '500+',
            label: 'Happy Clients',
            color: 'text-blue-600'
        },
        {
            icon: TrendingUp,
            number: '₹50Cr+',
            label: 'Assets Under Management',
            color: 'text-green-600'
        },
        {
            icon: Award,
            number: '15+',
            label: 'Industry Awards',
            color: 'text-yellow-600'
        },
        {
            icon: Building,
            number: '3',
            label: 'Office Locations',
            color: 'text-purple-600'
        }
    ];

    return (
        <section id="gallery" className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="text-center mb-16">
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                        Our Journey & Achievements
                    </h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                        Celebrating milestones, recognizing excellence, and showcasing the trust our clients place in us
                    </p>
                </div>

                {/* Milestones */}
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
                    {milestones.map((milestone, index) => {
                        const IconComponent = milestone.icon;
                        return (
                            <div key={index} className="text-center">
                                <div className={`inline-flex p-4 rounded-full bg-gray-100 mb-4`}>
                                    <IconComponent className={`h-8 w-8 ${milestone.color}`} />
                                </div>
                                <div className="text-3xl font-bold text-gray-900 mb-2">{milestone.number}</div>
                                <div className="text-gray-600">{milestone.label}</div>
                            </div>
                        );
                    })}
                </div>

                {/* Gallery Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {achievements.map((item, index) => (
                        <a
                            key={index}
                            href={`./${item.image}`}
                            target='_blank'
                        >
                            <div

                                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
                            >
                                <div className="aspect-w-16 aspect-h-12">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                                    />
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent">
                                    <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                                        <h3 className="text-lg font-bold mb-2">{item.title}</h3>
                                        <p className="text-gray-200 text-sm">{item.description}</p>
                                    </div>
                                </div>
                                <div className="absolute inset-0 bg-blue-600/0 group-hover:bg-blue-600/20 transition-colors duration-300"></div>
                            </div>
                        </a>
                    ))}
                </div>

                <div className='mt-10 w-full  flex items-center justify-center'>

                    <button
                        onClick={() => (navigate('/images'))}
                        className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200">
                        Show more images
                    </button>
                </div>

                {/* Testimonial Section */}
                <div className="mt-20 bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-8 lg:p-12">
                    <div className="text-center">
                        <div className="mb-6">
                            <div className="w-16 h-16 bg-blue-600 rounded-full mx-auto flex items-center justify-center">
                                <Users className="h-8 w-8 text-white" />
                            </div>
                        </div>
                        <blockquote className="text-xl lg:text-2xl text-gray-700 font-medium italic mb-6">
                            "Saisamriddhi has been instrumental in helping us achieve our financial goals.
                            Their personalized approach and expert guidance have made all the difference in our investment journey."
                        </blockquote>
                        <div className="text-gray-600">
                            <div className="font-semibold">Rajesh Kumar</div>
                            <div>Client since 2019</div>
                        </div>
                    </div>
                </div>


            </div>
        </section>
    );
};

export default Gallery;